import { Day } from '@/types.d';

const formatDayAndTime = (day: Day, time: string) => {
  if (!day || !time) return '';
  return `${day} @ ${formatMilitaryTime(time)}`;
};

const formatMilitaryTime = (militaryTime: string) => {
  if (militaryTime.length === 3) {
    militaryTime = `0${militaryTime}`;
  }

  let hour = parseInt(militaryTime.slice(0, 2), 10);
  const minute = militaryTime.slice(2);
  const isPM = hour >= 12;

  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }

  const period = isPM ? 'PM' : 'AM';

  return `${hour}:${minute}${period}`;
};

export { formatDayAndTime, formatMilitaryTime };
